export const SPECS = {
  MinimumOrderStorefront: 'specs.stores.MinimumOrderStorefront',
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  PaypalUpdateShippingAndBilling: 'specs.stores.PaypalUpdateShippingAndBilling',
  showShippingMethodCashierExpressButton: 'specs.stores.ShowShippingMethodInApplePayModal',
  EcomPlatformCartAndCheckout: 'specs.stores.EcomPlatformCartAndCheckout',
  AddPickupPointsToCart: 'specs.stores.AddPickupPointsToCart',
  SecureCheckoutVelo: 'specs.stores.ShowHideSecureCheckoutVelo',
  PickupPointsBmPhase1: 'specs.stores.PickupPointsBmPhase1',
  DisplayMixedCart: 'specs.stores.DisplayMixedCart',
  DisplayViolations: 'specs.stores.DisplayViolations',
  UseNewCheckoutInFastFlow: 'specs.stores.UseNewCheckoutInFastFlow',
  ShouldEnableANonClickableLineItem: 'specs.stores.ShouldEnableANonClickableLineItem',
  ShouldReportIsMember: 'specs.stores.ShouldReportIsMember',
  UseExpressCheckoutButtonsLibraryForCart: 'specs.stores.UseExpressCheckoutButtonsLibraryForCart',
  CartOOIThunderboltCSSOptimization: 'specs.stores.CartOOIThunderboltCSSOptimization',
  UseNewCheckoutForNonStoresFlows: 'specs.stores.UseNewCheckoutForNonStoresFlows',
  HideDeliveryMethodPickerWithTimeSlots: 'specs.stores.HideDeliveryMethodPickerWithTimeSlots',
  GetCartWithEcomId: 'specs.stores.GetCartWithEcomId',
  ShowCheckoutButtonForExpressOnlyPaymentMethods: 'specs.stores.ShowCheckoutButtonForExpressOnlyPaymentMethods',
} as const;
